<script>
  import { onMount } from "svelte";
  import Marquee from 'svelte-fast-marquee';

  import Message from "../Message.svelte";
  import Clock from "../Clock.svelte";

  import { parseMode } from "../helpers";
  import { replaceStopName } from "../helpers";
  import { tooltip } from '../utils'
  import { getLocalStorage } from '../utils';
  import { VERSION } from "../version"

  export let id;
  export let limit;
  export let style;
  export let type;
  export let systemUrl;

  let hashHeader = getLocalStorage('instanceId')

  localStorage.setItem('board-version', VERSION)

  let allowed_ids = [] // para todos

  if(VERSION.includes('prod')){
    allowed_ids = ['MOBVNF:01000','MOBVNF:01000_1','MOBVNF:01000_10','MOBVNF:01000_11','MOBVNF:01000_12','MOBVNF:01000_13',
      'MOBVNF:01000_14','MOBVNF:01000_15','MOBVNF:01000_16','MOBVNF:01000_17','MOBVNF:01000_18','MOBVNF:01000_19',
      'MOBVNF:01000_2','MOBVNF:01000_20','MOBVNF:01000_21','MOBVNF:01000_3','MOBVNF61_4','MOBVNF:01000_5',
      'MOBVNF:01000_6','MOBVNF:01000_7','MOBVNF:01000_8','MOBVNF:01000_9']
  }

  let data = {};

  let show_clock = true;
  let show_date = false;

  let request_type = (type == 'departures' || type == 'arrivals') ? type : 'departures';

  let currDate = 0

  const request = async () => {

    if(allowed_ids.length > 0 && allowed_ids.find(item => item == id) == undefined){
      console.log("Not allowed");
      return;
    }

    limit = isNaN(parseInt(limit)) ? 10 : parseInt(limit);

    const res = await fetch(
      `https://${systemUrl}/v3/busdata/stop?stop_id=${id}&type=${request_type}&limit=${limit}`,
      {
        headers: {
            'device-id': hashHeader,
            'board-version': VERSION
        }
      }
    );
    const resJson = await res.json();

    let results = [];

    currDate = resJson.time_utc;

    resJson.services.map((d) => {

      if (d.next != null) {
        let next_arrival_date;
        let next_arrival_date_delay;
        let next_departure_date;
        let next_load;
        let next_next_arrival_date;
        let next_next_arrival_date_delay;
        let next_next_departure_date;
        let next_next_departure_date_delay;
        let next_next_load;

        if (d.next2 != null) {
          next_arrival_date = Math.floor(d.next2.arrival_ms / 1000 / 60);
          next_arrival_date_delay = Math.floor(d.next2.arrival_delay_ms / 1000 / 60);
          next_departure_date = Math.floor(d.next2.departure_ms / 1000 / 60);
          next_load = d.next2.load;
        }

        if (d.next3 != null) {
          next_next_arrival_date = Math.floor(d.next3.arrival_ms / 1000 / 60);
          next_next_arrival_date_delay = Math.floor(d.next3.arrival_delay_ms / 1000 / 60);
          next_next_departure_date = Math.floor(d.next3.departure_ms / 1000 / 60);
          next_next_load = d.next3.load;
        }

        let dest = ''

        switch (d.agency) {
          case "FLX":
            dest = d.next.destination.replace('FlixBus: ','')  + ' : destino ' + d.next.last_stop_name;
            break;
          case "RNE":
            dest = d.next.destination;
            break;
          default:
            dest = d.next.stop_sequence == d.next.max_stop_sequence ? d.next.original_route_long_name : d.next.destination
        }
        
        results.push({
          id: d.no,
          line: d.next.line,
          destination: replaceStopName(dest),
          platform: d.next.platform != null ? d.next.platform : "" ,
          arrivalTimeRelative: Math.max(0,Math.floor(d.next.arrival_ms / 1000 / 60)),
          arrivalTimeRelativeDelay: Math.max(0,Math.floor(d.next.arrival_delay_ms / 1000 / 60)),
          arrivalDelay: Math.floor((d.next.arrival_delay_ms - d.next.arrival_ms) / 1000 / 60),
          departureTimeRelative: Math.max(0,Math.floor(d.next.departure_ms / 1000 / 60)),
          nextArrivalTimeRelative: next_arrival_date != null ? next_arrival_date : "",
          nextArrivalTimeRelativeDelay: next_arrival_date_delay != null ? next_arrival_date_delay : "",
          nextDepartureTimeRelative: next_departure_date != null ? next_departure_date : "",
          nextNextArrivalTimeRelative: next_next_arrival_date != null ? next_next_arrival_date : "",
          nextNextArrivalTimeRelativeDelay: next_next_arrival_date_delay != null ? next_next_arrival_date_delay : "",
          nextNextDepartureTimeRelative: next_next_departure_date != null ? next_next_departure_date : "",
          mode: parseMode(d.agency,dest),
          nextLoad: d.next.load,
          next2Load: next_load != null ? next_load : "",
          next3Load: next_next_load != null ? next_next_load : "",
        });
      }
    });

    data.name = resJson.name;
    data.departures = results.slice(0, limit)

  };

  onMount(() => {
    if (hashHeader != null) {
      request(); // first request
    } else {
      setTimeout(() => { // wait for js has time to calculate hashHeader and set it on localStorage
        hashHeader = getLocalStorage('instanceId')
        if (hashHeader != null) {
          request(); // first request
        } else {
          setTimeout(() => { // wait again for js has time to calculate hashHeader and set it on localStorage
            hashHeader = getLocalStorage('instanceId')
            request()
          }, 3000);
        }
        request()
      }, 1000);
    }

    const interval = setInterval(request, 60000); // request every 60 seconds

    return () => {
      clearInterval(interval);
    };
  });
</script>
{#if style == 0}
  <div class="flex-1 w-1/2 font-2" data-id={`stop-${id}`}>
    {#if data}
      {#if data.name}
        <div class="">
          <div class="flex flex-col w-full h-full whitespace-nowrap ">
            <div class="flex flex-col w-full h-full whitespace-nowrap absolute">
              <span class="text-2xl text-white text-center mt-2">
                <Clock {currDate} {show_clock} {show_date}/>
              </span>
            </div>
            <div class="flex flex-row h-11 text-2xl border-style-bottom">
              <div class="w-36 flex-shrink-0 flex-grow-0 p-0 bg-black my-auto text-left font-2">
                Operador
              </div>
              <div class="flex-grow p-0 bg-black my-auto text-left font-2">
                Linha
              </div>
              <div class="w-16 flex-shrink-0 flex-grow-0 p-0 bg-black my-auto text-center font-2">
                Cais
              </div>
              <div class="w-36 p-0 bg-black my-auto text-center">
                <p class="font-2">Partidas</p>
              </div>
            </div>
            {#each data.departures as { id, line, destination, arrivalTimeRelative, arrivalTimeRelativeDelay, arrivalDelay, nextArrivalTimeRelative, nextNextArrivalTimeRelative, mode, platform, nextLoad, next2Load, next3Load }}
              <div class="flex flex-row h-auto text-4xl text-primary border-style-bottom" data-id={id}>
                <div class="w-32 flex-shrink-0 flex-grow-0 bg-black align-middle text-left text-operador font-2">
                  {mode.name}
                </div>
                <div class="w-16 flex-shrink-0 flex-grow-0 align-middle text-center font-bold font-2 font-small">
                  {line}
                </div>
                <div class="flex-grow align-middle text-left overflow-hidden overflow-ellipsis font-small font-2">
                  {#if destination.length > 40}
                    <Marquee pauseOnHover={false} speed={destination.length * 0.3}>
                      <strong class="pr-10">{destination}</strong>
                    </Marquee>
                  {:else}
                    <strong>{destination}</strong>
                  {/if}
                </div>
                <div class="w-12 flex-shrink-0 flex-grow-0  align-middle text-center border-style-left font-2">
                  {#if platform}
                    <strong>{platform}</strong>
                  {:else}
                    <strong>--</strong>
                  {/if}
                </div>
                <div class="w-24 flex-shrink-0 flex-grow-0 text-right border-style-left next-text-0 font-2">
                  {#if arrivalTimeRelativeDelay == 0}
                    <div class="inline-flex">
                      <span class="minutes-text ml-2 fade-text">A partir</span>
                    </div>
                  {:else}
                    {#if arrivalTimeRelativeDelay != arrivalTimeRelative}
                      {#if nextLoad == 'DELAY' || nextLoad == 'DELAYPLUS'}
                        <div class="inline-block">
                          <img src="../img/svg/delay-2.svg" alt="Atrasado" class="delay mr-2"/>
                        </div>
                      {:else}
                        <div class="inline-block">
                          <!--<img src="../img/svg/delay-2.svg" alt="Atrasado" class="delay"/>-->
                        </div>
                      {/if}
                    {/if}
                    {arrivalTimeRelativeDelay}<span class="minutes-text ml-1">min</span>
                  {/if}
                </div>
                <div class="w-12 flex-shrink-0 flex-grow-0 text-right next-next-text-0 font-2 ml-2">
                  {#if nextArrivalTimeRelative != 0}
                    {nextArrivalTimeRelative}<span class="minutes-next-text ml-1">min</span>
                  {/if}
                </div>
              </div>
            {:else}
              <div class="table-row font-2">
                <Message title="Sem partidas previstas..." text="Não existem partidas definidas para esta paragem para as próximas horas."/>
              </div>
            {/each}
          </div>
        </div>
      {:else}
        <div class="">
          <Message title="Sem partidas previstas..." text="Não existem partidas definidas para esta paragem para as próximas horas."/>
        </div>
      {/if}
    {:else}
      <Message title="Iremos ser breves..." text="Estamos com alguns problemas a mostrar a informação ({id})"/>
    {/if}
  </div>

{:else }

  <div class="flex-1 w-1/2 font-1" data-id={`stop-${id}`}>
  {#if data}
    {#if data.name}
      <div class="">
          <div class="px-2 relative flex items-center justify-between">
            <div class="flex items-center">
              <img class="logo-system mx-3" alt="Logo Cidade" src="img/logo-{id.substring(0,3)}.png">
              <p class="title  ml-4">{data.name}</p>
            </div>
          </div>
        <div class="flex flex-col w-full h-full whitespace-nowrap ">
          <div class="flex flex-row h-20 text-2xl border-style-bottom">
              <div class="w-18rem flex-shrink-0 flex-grow-0 p-2 bg-black my-auto text-left" use:tooltip={VERSION}>
                Operador
              </div>
            <div class="flex-grow bg-black my-auto text-left">
              Linha
            </div>
            <div class="w-24 flex-shrink-0 flex-grow-0 p-2 bg-black my-auto text-center">
              Cais
            </div>
            <div class="w-17rem p-2 bg-black my-auto text-center ">
              <p class="tempos-text">Partidas<br><span class="minutes-text">em min</span></p>
            </div>
          </div>
          {#each data.departures as { id, line, destination, arrivalTimeRelative, arrivalTimeRelativeDelay, arrivalDelay, nextArrivalTimeRelative, nextNextArrivalTimeRelative, mode, platform, nextLoad, next2Load, next3Load }}
            <div class="flex flex-row h-16 text-4xl text-primary border-style-bottom" data-id={id}>
                <div class="w-16 flex-shrink-0 flex-grow-0 p-1 align-middle">
                  <img class="h-full w-full" src={mode.iconUrl} alt={mode.name} />
                </div>
                <div class="w-52 flex-shrink-0 flex-grow-0 p-3 bg-black align-middle text-left text-operador">
                  {mode.name}
                </div>
              <div class="w-28 flex-shrink-0 flex-grow-0 p-3 align-middle text-center font-bold text-primary-light">
                {line}
              </div>
              {#if destination.length > 40 }
                <Marquee pauseOnHover={false} speed={destination.length * 0.3}>
                  <span class="pr-10">{destination}</span>
                </Marquee>
              {:else}
                <div class="flex-grow text-left pr-2 my-auto">
                  {destination}
                </div>
              {/if}
              <div class="w-24 flex-shrink-0 flex-grow-0 p-2 align-middle text-center border-style-left text-primary-light">
                {#if platform}
                  <p class="next-text">{platform}</p>
                {:else}
                  <p class="next-text">--</p>
                {/if}
              </div>
              <div class="w-36 flex-shrink-0 flex-grow-0 p-2 my-auto text-right text-primary-light border-style-left next-text">
                {#if arrivalTimeRelativeDelay == 0}
                  <div class="inline-flex">
                    <img src="../img/svg/bus-single.svg" alt="Chegada" class="bus-arrive"/>
                    <span class="minutes-text ml-2 fade-text">A partir</span>
                  </div>
                {:else}
                  {#if arrivalTimeRelativeDelay != arrivalTimeRelative}
                    {#if nextLoad == 'DELAY' || nextLoad == 'DELAYPLUS'}
                      <div class="inline-block">
                        <img src="../img/svg/delay-2.svg" alt="Atrasado" class="delay"/> 
                      </div>
                    {:else}
                      <div class="inline-block">
                        <!--<img src="../img/svg/delay-2.svg" alt="Atrasado" class="delay"/>-->
                      </div>
                    {/if}
                  {/if}
                  {arrivalTimeRelativeDelay}<span class="minutes-text ml-1" use:tooltip={arrivalDelay}>min</span>
                {/if}
              </div>
              <div class="w-16 flex-shrink-0 flex-grow-0 p-2 my-auto text-right text-primary-light next-next-text">
                {#if nextArrivalTimeRelative != 0}
                  {nextArrivalTimeRelative}<span class="minutes-next-text ml-1">min</span>
                {/if}
              </div>
              <div class="w-16 flex-shrink-0 flex-grow-0 p-2 my-auto text-right text-primary-light next-next-text">
                {#if nextNextArrivalTimeRelative != 0}
                  {nextNextArrivalTimeRelative}<span class="minutes-next-text ml-1">min</span>
                {/if}
              </div>
            </div>
          {:else}
            <div class="table-row">
              <Message title="Sem partidas previstas..." text="Não existem partidas definidas para esta paragem para as próximas horas."/>
            </div>
          {/each}
        </div>
      </div>
    {:else}
      <div class="">
        <div class="px-2 relative flex items-center justify-between">
          <div class="flex items-center">
          <img class="logo-system mx-3" alt="Logo Cidade" src="img/logo-{id.substring(0,3)}.png">
          <p class="title  ml-4">{data.name}</p>
          </div>
        </div>
        <Message title="Sem partidas previstas..." text="Não existem partidas definidas para esta paragem para as próximas horas."/>
      </div>
    {/if}
  {:else}
    <Message title="Iremos ser breves..." text="Estamos com alguns problemas a mostrar a informação ({id})"/>
  {/if}
</div>
{/if}
